import { ReportChecklistData } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';

interface Props {
  checklist: ReportChecklistData;
}

const ReportChecklistRequestServices: React.FC<Props> = ({ checklist }) => {
  return (
    <table
      className={`reportChecklist-requestServices ${
        checklist.company?.bosch ? '-bosch' : ''
      }`}
    >
      <thead>
        <tr>
          <th>Serviços solicitados (inspeção/manutenção/reparação)</th>
          <th>Observação</th>
        </tr>
      </thead>

      <tbody>
        {!checklist.checklistRequestedServices?.length && (
          <tr>
            <td className="empty" colSpan={2}>
              Não há serviços solicitados
            </td>
          </tr>
        )}
        {checklist.checklistRequestedServices?.map((item) => (
          <tr key={item.id}>
            <td>{item.requestedService}</td>
            <td>{item.comments}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ReportChecklistRequestServices;
